define('modeSelector/starter',['Vue', 'vue','vuex','moment','es6-promises','es6-promises-auto'],
    function (Vue, vue, vuex,moment) {
        var localStrings = app.localization.spaBooking.packageBooking;
        return function(params){
            Vue.use(vuex);
            Vue.mixin({
                methods: {
                    goNext: function() {
                        app.views[params.view].event.fire(params.event,params.paramsArr);
                    },
                    a11yKeyDown: function(e, handlers) {
                        switch(e.keyCode) {
                            case 38: handlers.up && handlers.up();
                                    break;
                            case 40: handlers.down && handlers.down();
                                    break;
                            case 37: handlers.left && handlers.left();
                                    break;
                            case 39: handlers.right && handlers.right();
                                    break;
                            case 13: handlers.enter && handlers.enter();
                                    break;
                            case 9: if(e.shiftKey){ handlers.shiftTab && handlers.shiftTab(); }
                                    else handlers.tab && handlers.tab();
                                    break;
                            case 32: handlers.space && handlers.space();
                            case 27: handlers.escape && handlers.escape();
                        }
                    }
                },
                data: function(){
                    return {
                        localStrings: localStrings,
                        localization: app.localization
                    }
                }
            });
            Vue.directive('click-outside', {
                bind: function (el, binding, vnode) {
                    this.event = function (event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        vnode.context[binding.expression](event);
                    }
                    };
                    document.body.addEventListener('click', this.event)
                },
                unbind: function (el) {
                    
                },
            });
            require(['vue!modeSelector/components/container','app/views/vue/store/store','helpers'], function (vueApp,store,helpers) {
                helpers.updateNavBar();
                var vm1 = new Vue({
                    el:'#vue-app-mode',
                    store: store,
                   render: function(h){ return h(vueApp) }
                });
                app.datal('modeSelectorVueAppRef',vm1);
            });
        }
    }
);
